import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { TitlePagePrevieWrapper } from "app/pages/digital-marketing/AnalysisHomePageTrial/AnalysisHomePageTrialStyle";
import { Box } from "app/pages/keyword-research/keyword-analysis/pages/serp-snapshot/StyledComponents";
import { AssetsService } from "app/services/AssetsService";
import { PagePreviewWrapper } from "pro-features/components/PagePreview/styledComponents";
import { CenteredFlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const CardWrapper = styled(Box)`
    justify-content: space-between;
    border: solid 1px ${colorsPalettes.carbon["0"]};
    transition: all 0.2s linear;
    width: 810px;
    box-shadow: 0 3px 6px rgba(14, 30, 62, 0.08);
    &:hover {
        border: solid 1px ${colorsPalettes.navigation.BORDER_DARK_2};
        box-shadow: 0 3px 5px 0 rgba(42, 62, 82, 0.12);
    }
    height: 84px;
    background-color: ${colorsPalettes.carbon["0"]};
    display: flex;
    max-width: 100%;
    align-items: center;
    padding: 8px 16px;
    margin-bottom: 16px;
    cursor: pointer;
    border-radius: 8px;
    box-sizing: border-box;
`;

export const HomePage = styled(CenteredFlexColumn)`
    align-items: center;
    background: url(${AssetsService.assetUrl("/images/homepage-gradient.png")}) top no-repeat;
    justify-content: start;
    background-size: cover;
    z-index: 1;
    width: 100%;
    &:before {
        content: "";
        z-index: -1;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background:
            url(${AssetsService.assetUrl("/images/common/attach-left.svg")}),
            url(${AssetsService.assetUrl("/images/halfCircleRightTop.svg")});
        background-repeat: no-repeat, no-repeat;
        background-position:
            left top,
            right top;
    }
`;

export const HomepageContentWrapper = styled(CenteredFlexColumn)`
    width: 900px;
`;

export const HeadersSection = styled(CenteredFlexColumn)`
    padding-top: 100px;
    padding-bottom: 60px;
    width: 100%;
    gap: 40px;
    z-index: 1;
    @media only screen and (max-width: 1400px) {
        padding-top: 90px;
        padding-bottom: 40px;
    }
    @media only screen and (max-width: 1350px) {
        padding-top: 80px;
        padding-bottom: 35px;
    }
    @media only screen and (max-width: 1280px) {
        padding-top: 60px;
        padding-bottom: 35px;
    }
`;

export const TitlesHeader = styled(CenteredFlexColumn)`
    gap: 12px;
`;

export const Title = styled.span`
    width: 100%;
    text-align: center;
    line-height: 40px;
    padding-bottom: 8px;
    ${setFontVariant("h2", colorsPalettes.carbon[500])};
    @media only screen and (max-width: 1400px) {
        ${setFontVariant("h3", colorsPalettes.carbon[500])};
    }
    @media only screen and (max-width: 1280px) {
        ${setFontVariant("h4", colorsPalettes.carbon[500])};
        line-height: 24px;
    }
`;
export const SubTitle = styled.span`
    max-width: 600px;
    ${setFontVariant("body1", colorsPalettes.carbon[400])};
    line-height: 20px;
    text-align: center;
    white-space: pre-line;
    @media only screen and (max-width: 1400px) {
        ${setFontVariant("body1", colorsPalettes.carbon[400])};
        line-height: 20px;
    }
    @media only screen and (max-width: 1280px) {
        ${setFontVariant("body2", colorsPalettes.carbon[400])};
        line-height: 20px;
    }
`;

export const LineTitle = styled.div`
    border-top: 1px solid ${colorsPalettes.carbon[100]};
    flex: 1;
    transform: rotate(-180deg);
`;
export const HomepageInnerWrapper = styled(CenteredFlexColumn)`
    width: 100%;
    margin: auto;
    ${TitlePagePrevieWrapper} {
        width: 100%;
    }
    ${PagePreviewWrapper} {
        width: 100%;
    }
`;
